import { render, staticRenderFns } from "./PublicHolidayRegionCreate.vue?vue&type=template&id=8f5b5384&scoped=true"
import script from "./PublicHolidayRegionCreate.vue?vue&type=script&lang=js"
export * from "./PublicHolidayRegionCreate.vue?vue&type=script&lang=js"
import style0 from "./PublicHolidayRegionCreate.vue?vue&type=style&index=0&id=8f5b5384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5b5384",
  null
  
)

export default component.exports